import { render } from "./ThirdPlatform.vue?vue&type=template&id=0a9fb4d2&scoped=true"
import script from "./ThirdPlatform.vue?vue&type=script&lang=js"
export * from "./ThirdPlatform.vue?vue&type=script&lang=js"

import "./ThirdPlatform.vue?vue&type=style&index=0&id=0a9fb4d2&lang=less"
import "./ThirdPlatform.vue?vue&type=style&index=1&id=0a9fb4d2&lang=less&scoped=true"

import exportComponent from "F:\\workspace\\clientapps\\Advertising-Platform\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9fb4d2"]])

export default __exports__